import { render, staticRenderFns } from "./HolidayPopup.vue?vue&type=template&id=af58654a&"
import script from "./HolidayPopup.vue?vue&type=script&lang=js&"
export * from "./HolidayPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports